"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M12 2c-.46 0-.85.32-.97.74L7.04 16.7c-.02.1-.04.2-.04.3 0 .55.45 1 1 1 .46 0 .85-.32.97-.74L12.96 3.3c.02-.1.04-.2.04-.3 0-.55-.45-1-1-1z"];
//# sourceMappingURL=slash.js.map